<input inputRestriction class="unnanu-text-input-style-1 form-control city-suggestions-input"
	[ngClass]="{'error': showCityError}" (blur)="hideCitySuggestions()" [(ngModel)]="city" type="" name="" id=""
	value="" [placeholder]="Joblocation ? 'Your home city' : 'Job Location'" [ngbTypeahead]="search" (selectItem)="citySelectedFn($event)"
	[resultFormatter]="formatter">
